import { lodash } from 'helpers';
import { useTranslation } from 'libs/i18n';
import { Field } from 'modules/order/order/forms/orderForm';

import { OrderSection } from '../../OrderSection';

export const AdditionalNotesSection = () => {
  const { t } = useTranslation();

  return (
    <OrderSection
      fields={lodash.compact([
        <Field.Text
          fullWidth
          multiline
          label={t(
            'order.sections.additionalNotesSection.fields.additionalNotes.label'
          )}
          name="executionTerms.additionalNotes"
          placeholder={t(
            'order.sections.additionalNotesSection.fields.additionalNotes.placeholder'
          )}
        />,
      ])}
      title={t('order.sections.additionalNotesSection.title')}
    />
  );
};
